import React from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import UIcon, { IconKey } from "lib/icons/untitled_ui/UIcon";
import { type BidResponseStageOption, GroupedBidResponseStageOptions } from "./utils";

export function BidResponseStageOptionRenderer({
  label,
  value,
  options,
}: {
  label: React.ReactNode;
  value: string;
  options: GroupedBidResponseStageOptions[];
}) {
  const option = findBidResponseStageOptionByValue(value, options);
  if (!option) return <>{label}</>;

  return (
    <StageSelectTagContainer backgroundColor={option.color || "transparent"}>
      {option.iconName && <Icon icon={option.iconName as IconKey} color={option.iconColor} />}
      {option.label}
    </StageSelectTagContainer>
  );
}

export function findBidResponseStageOptionByValue(
  value: string,
  options: GroupedBidResponseStageOptions[],
): BidResponseStageOption | undefined {
  for (const group of options) {
    const option = group.options.find((opt) => opt.value === value);
    if (option) return option;
  }
  return undefined;
}

const StageSelectTagContainer = styled(Flex)<{ backgroundColor: string }>(
  ({ backgroundColor, theme }) => ({
    display: "flex",
    alignItems: "center",
    color: theme.colors.sysTextDefault,
    gap: 8,
    width: "max-content",
    minHeight: 26,
    padding: "2px 8px",
    backgroundColor,
    borderRadius: 2,
    lineHeight: 1,
  }),
);

const Icon = styled(UIcon)({
  width: 12,
  height: 12,
  flexShrink: 0,
});
